import React from 'react';
import {
  Create,
  Datagrid,
  DateField,
  Edit,
  EditButton,
  FormTab,
  ImageField,
  ImageInput,
  List,
  LongTextInput,
  NumberField,
  NumberInput,
  SaveButton,
  SelectField,
  SelectInput,
  SimpleForm,
  TabbedForm,
  TextField,
  TextInput,
  Toolbar
} from 'react-admin';

export const ImageArrayFormatter = v => {
  console.log("====PhotoArrayFormatter=====: ", v);
  let photoArray = [];
  if (typeof v === 'undefined') {
    return v;
  }
  if (v.length && typeof v[0] !== 'object') {
    v.map(photo => {
      const imageObj = typeof photo !== 'object' ? {
        "src": photo
      } : photo

      photoArray.push(imageObj);
    })
    return photoArray;
  } else {
    return v;
  }

}

export const ImageArrayParser = v => {
  console.log("====PhotoArrayParser=====: ", v);
  return v.map((image, i) => {
    return !image.rawFile
      ? image.src
      : image
  });
}

const required = (message = 'Required') =>
  value => value ? undefined : message;

export const MealList = (props) => (
  <List {...props} title="List of Meals" bulkActionButtons={false}>
    <Datagrid>
      <DateField source="created_at" showTime/>
      <TextField source="name"/>
      <SelectField source="audience_type" choices={[
        { id: 'FREE', name: 'Free' },
        { id: 'PREMIUM', name: 'Premium' },
      ]} />
      <NumberField source="order"/>
      <DateField source="updated_at" showTime/>
      <EditButton/>
    </Datagrid>
  </List>
);

export const MealCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="/meals">
      <LongTextInput source="name" />
      <LongTextInput source="description"/>
      <LongTextInput source="ingredients"/>
      <LongTextInput source="instructions"/>
      <TextInput source="video"/>
      <SelectInput source="audience_type" choices={[
        { id: 'FREE', name: 'Free' },
        { id: 'PREMIUM', name: 'Premium' }
      ]} />
      <ImageInput source="photos" label="Photos" accept="image/*" multiple
                  format={ImageArrayFormatter} parse={ImageArrayParser} >
        <ImageField source="src" title="title"/>
      </ImageInput>
      <NumberInput source="order"/>
    </SimpleForm>
  </Create>
);

const EditToolbar = props => (
  <Toolbar {...props} >
    <SaveButton/>
  </Toolbar>
);

export const MealEdit = (props) => (
  <Edit {...props} undoable={false}>
    <TabbedForm redirect="/meals">
      <FormTab label="Screen Info">
        <LongTextInput source="name" />
        <LongTextInput source="description"/>
        <LongTextInput source="ingredients"/>
        <LongTextInput source="instructions"/>
        <TextInput source="video"/>
        <SelectInput source="audience_type" choices={[
          { id: 'FREE', name: 'Free' },
          { id: 'PREMIUM', name: 'Premium' }
        ]} />
        <ImageInput source="photos" label="Photos" accept="image/*" multiple
                    format={ImageArrayFormatter} parse={ImageArrayParser} >
          <ImageField source="src" title="title"/>
        </ImageInput>
        <NumberInput source="order"/>
      </FormTab>
    </TabbedForm>
  </Edit>
);